import React, { useState, useEffect } from 'react';

export const CurrencyInput = ({ value, onChange, placeholder, className, required = false }) => {
  const [displayValue, setDisplayValue] = useState('');

  useEffect(() => {
    // Formatar valor inicial
    if (value !== undefined && value !== null && value !== '') {
      const formatted = formatCurrency(value);
      setDisplayValue(formatted);
    } else {
      setDisplayValue('');
    }
  }, [value]);

  const formatCurrency = (num) => {
    // Converte número para formato brasileiro
    const number = parseFloat(num) || 0;
    return number.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const handleChange = (e) => {
    let input = e.target.value;
    
    // Remove tudo exceto dígitos
    const digits = input.replace(/\D/g, '');
    
    if (digits === '') {
      setDisplayValue('');
      onChange(0);
      return;
    }

    // Converte para número (considerando últimos 2 dígitos como centavos)
    const number = parseFloat(digits) / 100;
    
    // Formata para exibição
    const formatted = number.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    
    setDisplayValue(formatted);
    onChange(number);
  };

  const handleFocus = () => {
    // Quando focar, se for 0, limpa
    if (parseFloat(displayValue.replace(/\./g, '').replace(',', '.')) === 0) {
      setDisplayValue('');
    }
  };

  const handleBlur = () => {
    // Quando sair do campo, se estiver vazio, coloca 0,00
    if (displayValue === '') {
      setDisplayValue('0,00');
      onChange(0);
    }
  };

  return (
    <div className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground font-medium text-sm pointer-events-none z-10">
        R$
      </span>
      <input
        type="text"
        value={displayValue}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder={placeholder || "0,00"}
        className={`${className} pl-12`}
        required={required}
        style={{ paddingLeft: '2.5rem' }}
      />
    </div>
  );
};
